import { HeroProps } from "../../HeroProps";
import Lobby from "../../lobby/Lobby";
import { cdnUrl, translate } from "@kaltura/mediaspace-shared-utils";
import { CommonHeroLayout } from "../../layout/CommonHeroLayout";

/**
 * media-page conversion error component
 */
export function ConversionError(props: HeroProps) {
    const { entry, actions } = props;

    return (
        <CommonHeroLayout>
            <Lobby
                thumbnailUrl={cdnUrl + "/media/Thumbnail.png"}
                videoUrl={cdnUrl + "/media/Thumbnail.mp4"}
                statusLabel={translate("error processing media")}
                title={entry.name}
                actions={actions}
            />
        </CommonHeroLayout>
    );
}

export default ConversionError;
